import {
  GET_CONTACTS_SUBJECTS,
  GET_CONTACTS_SUBJECTS_SUCCESS,
  GET_CONTACTS_SUBJECTS_FAILURE,
  SEND_CONTACTS_INCIDENT,
  SEND_CONTACTS_INCIDENT_SUCCESS,
  SEND_CONTACTS_INCIDENT_FAILURE,
} from "@store/contacts/constants";

import { makeApiCall } from "@lib/api/helpers";

import { getContactsSubjectsApi, sendContactsIncidentApi } from "@lib/api";

export const getSubjects = () => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_CONTACTS_SUBJECTS,
      success: GET_CONTACTS_SUBJECTS_SUCCESS,
      fail: GET_CONTACTS_SUBJECTS_FAILURE,
    },
    dispatch,
    getState,
    spinner: false,
    alert: false,
    alertMessage: `Get product couldn't be completed...`,
    apiCall: getContactsSubjectsApi,
    apiArgs: [],
    formatResponse: (response) => {
      if (response?.data) {
        const {
          levels: { max_levels, fields },
          types,
        } = response.data;

        if (fields && Object.keys(fields).length && types?.length) {
          const fieldsFilteredByLevel = fields.reduce((fieldObj, field) => {
            const options = types.filter((type) => type.Level === field.level);

            fieldObj[field.level] = {
              level: field.level,
              fieldName: field.field,
              label: field.label,
              options: options,
            };

            return fieldObj;
          }, {});

          return {
            fieldsFilteredByLevel,
            maxLevel: max_levels || fields.length,
          };
        }
      }
    },
  });
};

export const sendIncident = (values) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: SEND_CONTACTS_INCIDENT,
      success: SEND_CONTACTS_INCIDENT_SUCCESS,
      fail: SEND_CONTACTS_INCIDENT_FAILURE,
    },
    dispatch,
    getState,
    spinner: false,
    alert: true,
    alertMessage: `Nu s-a putut trimite mesajul. Te rugam sa incerci din nou.`,
    apiCall: sendContactsIncidentApi,
    apiArgs: [values],
    formatResponse: (response) => response.data,
    returnResponse: true,
  });
};
